import { atlas } from '~/services/serviceInstances';

import {
  GetPlaybookByIdApiArg,
  GetPlaybookResponse,
} from '../../types/playbooks/playbooks';

export const getPlaybook = async ({
  playbookId,
}: GetPlaybookByIdApiArg): Promise<GetPlaybookResponse> => {
  return atlas.get<GetPlaybookResponse>(`playbooks/${playbookId}`);
};
